<template>
  <div class="chat_room">
    <div class="chat_record" ref="chatRecord">
      <div class="record_content">
        <div class="pulldown-tips">
          <div v-show="beforePullDown">
            <span>下拉获取更多聊天记录</span>
          </div>
          <div v-show="!beforePullDown">
            <div v-show="isPullingDown">
              <span>加载中...</span>
            </div>
            <div v-show="!isPullingDown"><span>加载成功</span></div>
          </div>
        </div>
        <div
          class="msg_item_list"
          ref="msgItemList"
          v-for="item in msgList"
          :key="item.id"
        >
          <div class="msg_item" v-if="!isMineMsg(item)">
            <div class="user_info">
              <div class="avatar">
                <a-tooltip placement="top" v-show="canIForbidUser(item)">
                  <template #title>
                    <span
                      style="cursor: pointer"
                      v-show="!forbidUsers.includes(item.data.uuid)"
                      @click="forbidChat(item, 1)"
                      >禁言</span
                    >
                    <span
                      style="cursor: pointer"
                      v-show="forbidUsers.includes(item.data.uuid)"
                      @click="forbidChat(item, 0)"
                      >解禁</span
                    >
                  </template>
                  <div>
                    <img :src="item.data.avatar || imUserInfo.avatar" alt="" />
                    <div
                      class="no_sound"
                      :style="{
                        display: forbidUsers.includes(item.data.uuid)
                          ? 'flex'
                          : '',
                      }"
                    >
                      <img
                        v-show="!forbidUsers.includes(item.data.uuid)"
                        @click="forbidChat(item, 1)"
                        src="../../assets/img/icon_nosound.png"
                        alt=""
                      />
                      <img
                        v-show="forbidUsers.includes(item.data.uuid)"
                        @click="forbidChat(item, 0)"
                        src="../../assets/img/icon_nosound_no.png"
                        alt=""
                      />
                    </div>
                  </div>
                </a-tooltip>
                <img
                  v-show="!canIForbidUser(item)"
                  :src="item.data.avatar || imUserInfo.avatar"
                  alt=""
                />
                <!-- <img :src="item.data.avatar" alt="" /> -->
              </div>
              <div
                class="name"
                :style="{ color: isMainSpaker(item) ? '#3982FF' : '#9fa2b1' }"
              >
                {{ item.data.nickName }}
                <span v-if="isMainSpaker(item)">（主讲）</span>
              </div>
            </div>
            <span class="msg_ctx" v-html="item.data.message"></span>
          </div>
          <div class="msg_item_mine" v-if="isMineMsg(item)">
            <div class="user_info">
              <div
                class="name"
                :style="{ color: isMainSpaker(item) ? '#3982FF' : '#9fa2b1' }"
              >
                {{ item.data.nickName }}
                <span v-if="isMainSpaker(item)">（主讲）</span>
              </div>
              <div class="avatar">
                <a-tooltip placement="top" v-show="canIForbidUser(item)">
                  <template #title>
                    <span
                      style="cursor: pointer"
                      v-show="!forbidUsers.includes(item.data.uuid)"
                      @click="forbidChat(item, 1)"
                      >禁言</span
                    >
                    <span
                      style="cursor: pointer"
                      v-show="forbidUsers.includes(item.data.uuid)"
                      @click="forbidChat(item, 0)"
                      >解禁</span
                    >
                  </template>
                  <div>
                    <img :src="item.data.avatar || imUserInfo.avatar" alt="" />
                    <div
                      class="no_sound"
                      :style="{
                        display: forbidUsers.includes(item.data.uuid)
                          ? 'flex'
                          : '',
                      }"
                    >
                      <img
                        v-show="!forbidUsers.includes(item.data.uuid)"
                        @click="forbidChat(item, 1)"
                        src="../../assets/img/icon_nosound.png"
                        alt=""
                      />
                      <img
                        v-show="forbidUsers.includes(item.data.uuid)"
                        @click="forbidChat(item, 0)"
                        src="../../assets/img/icon_nosound_no.png"
                        alt=""
                      />
                    </div>
                  </div>
                </a-tooltip>
                <img
                  v-show="!canIForbidUser(item)"
                  :src="item.data.avatar || imUserInfo.avatar"
                  alt=""
                />
                <!-- <img :src="item.data.avatar" alt="" /> -->
              </div>
            </div>
            <span class="msg_ctx" v-html="item.data.message"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="chat_send">
      <div>
        <div>
          <img
            src="../../assets/img/emoji.png"
            alt=""
            @click="showEmojiBox = !showEmojiBox"
          />
          <span v-show="showCtxTip">内容不能为空!</span>
        </div>
        <div>
          观看人数：<span>{{ onlineNum }}</span>
        </div>
      </div>
      <div>
        <a-textarea
          v-if="canIChat"
          ref="textarea"
          v-model="content"
          placeholder="请文明用语"
          @keydown.native.enter.prevent.stop="sendChatTextMsg"
          @change="handleCtxChange"
        />
        <div v-if="!canIChat" class="forbid_info_box">
          您已被禁言，无法参与互动～
        </div>
        <div class="emoji_box" v-show="showEmojiBox">
          <ul
            class="emotion ZHIHUISHU_QZMD"
            @click="(event) => handleEmojiClick(event)"
          >
            <!-- 1 -->
            <li id="[呲牙]" title="呲牙/cy"></li>
            <li id="[可爱]" title="可爱/ka"></li>
            <li id="[发怒]" title="发怒/fn"></li>
            <li id="[擦汗]" title="擦汗/ch"></li>
            <li id="[坏笑]" title="坏笑/huaix"></li>
            <li id="[惊恐]" title="惊恐/jk"></li>
            <li id="[流泪]" title="流泪/ll"></li>
            <li id="[偷笑]" title="偷笑/tx"></li>
            <!-- 2 -->
            <li id="[调皮]" title="调皮/tp"></li>
            <li id="[咒骂]" title="咒骂/zhm"></li>
            <li id="[委屈]" title="委屈/wq"></li>
            <li id="[晕]" title="晕/yun"></li>
            <li id="[抓狂]" title="抓狂/zk"></li>
            <li id="[色]" title="色/se"></li>
            <li id="[鄙视]" title="鄙视/bs"></li>
            <li id="[闭嘴]" title="闭嘴/bz"></li>
            <!-- 3 -->
            <li id="[发呆]" title="发呆/fd"></li>
            <li id="[困]" title="困/kun"></li>
            <li id="[抠鼻]" title="抠鼻/kb"></li>
            <li id="[阴险]" title="阴险/yx"></li>
            <li id="[吐]" title="吐/tuu"></li>
            <li id="[奋斗]" title="奋斗/fendou"></li>
            <li id="[惊讶]" title="惊讶/jy"></li>
            <li id="[流汗]" title="流汗/lh"></li>
            <!-- 4 -->
            <li id="[疑问]" title="疑问/yiw"></li>
            <li id="[嘘]" title="嘘/xu"></li>
            <li id="[冷汗]" title="冷汗/lengh"></li>
            <li id="[鼓掌]" title="鼓掌/gz"></li>
            <li id="[哈欠]" title="哈欠/hq"></li>
            <li id="[憨笑]" title="憨笑/hanx"></li>
            <li id="[得意]" title="得意/dy"></li>
            <li id="[亲亲]" title="亲亲/qq"></li>
            <!-- 5 -->
            <li id="[睡]" title="睡/shui"></li>
            <li id="[右哼哼]" title="右哼哼/yhh"></li>
            <li id="[左哼哼]" title="左哼哼/zhh"></li>
            <li id="[折磨]" title="折磨/zhem"></li>
            <li id="[快哭了]" title="快哭了/kk"></li>
            <li id="[可怜]" title="可怜/kel"></li>
            <li id="[糗大了]" title="糗大了/qd"></li>
            <li id="[傲慢]" title="傲慢/am"></li>
            <!-- 6 -->
            <li id="[吓]" title="吓/xia"></li>
            <li id="[酷]" title="酷/kuk"></li>
            <li id="[大兵]" title="大兵/db"></li>
            <li id="[饥饿]" title="饥饿/jie"></li>
            <li id="[衰]" title="衰/shuai"></li>
            <li id="[骷髅]" title="骷髅/kl"></li>
            <li id="[强]" title="强/qiang"></li>
            <li id="[弱]" title="弱/ruo"></li>
            <!-- 7 -->
            <li id="[敲打]" title="敲打/qiao"></li>
            <li id="[心碎]" title="心碎/xs"></li>
            <li id="[握手]" title="握手/ws"></li>
            <li id="[胜利]" title="胜利/shl"></li>
            <li id="[差劲]" title="差劲/cj"></li>
            <li id="[NO]" title="NO/bu"></li>
            <li id="[拳头]" title="拳头/qt"></li>
            <li id="[菜刀]" title="菜刀/cd"></li>
            <!-- 8 -->
            <li id="[炸弹]" title="炸弹/zhd"></li>
            <li id="[便便]" title="便便/bb"></li>
            <li id="[篮球]" title="篮球/lq"></li>
            <li id="[足球]" title="足球/zq"></li>
            <li id="[闪电]" title="闪电/shd"></li>
            <li id="[猪头]" title="猪头/zt"></li>
            <li id="[乒乓]" title="乒乓/pp"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import string2Emoji from '../../utils/string2emoji.js'
import BScroll from '@better-scroll/core'
import PullDown from '@better-scroll/pull-down'
import MouseWheel from '@better-scroll/mouse-wheel'
BScroll.use(MouseWheel)
BScroll.use(PullDown)
export default {
  name: 'ChatRoom',
  data() {
    return {
      content: '',
      liveId: '',
      showCtxTip: false,
      onlineNum: 0,
      showEmojiBox: false,
      forbidUsers: [],
      beforePullDown: true,
      isPullingDown: false,
      scrollPulldownNum: 0,
      bscroll: '',
    }
  },
  computed: {
    ...mapState({
      chatroom: (state) => state.imCommunication.chatroom,
    }),
    ...mapGetters('userInfo', ['userInfo', 'userId']),
    ...mapGetters('imCommunication', ['getIMMsgList', 'getRoleList']),
    msgList() {
      return this.getIMMsgList?.map((msg) => {
        return {
          ...msg,
          ...{
            data: {
              ...msg.data,
              message: string2Emoji(msg.data.message),
            },
          },
        }
      })
    },
    canIChat() {
      return !this.forbidUsers.includes(`admin_${this.userInfo.userId}`)
    },
  },
  mounted() {
    this.liveId = this.$route.query.liveId || ''
    this.initBscroll()
    this.getLiveOnlineNum()
    this.getForbidChatUsers()
    // setTimeout(() => {
    //   this.getChatroomMsgHistoryList()
    // }, 200)
    this.getChatRecords()
    this.setLeftBarName('textInteraction')
    // 取消新消息提示
    this.setIsHaveNewMsg(false)
    this.$bus.on('roomOnlineNumChange', this.roomOnlineNumChange)
    this.$bus.on('chatRoomScrollBottom', this.scrollBottom)
    this.$bus.on('forbidUserChange', this.forbidUserChange)
  },
  beforeDestroy() {
    this.setLeftBarName('')
    this.$bus.off(this.roomOnlineNumChange)
    this.$bus.off('chatRoomScrollBottom', this.scrollBottom)
    this.$bus.off('forbidUserChange', this.forbidUserChange)
  },
  methods: {
    ...mapMutations('imCommunication', {
      setIMMsgList: 'setIMMsgList',
      addIMMsg: 'addIMMsg',
      setLeftBarName: 'setLeftBarName',
      setIsHaveNewMsg: 'setIsHaveNewMsg',
    }),
    isMineMsg(item) {
      return item.data.uuid == `admin_${this.userInfo.userId}`
    },
    isMainSpaker(msg) {
      const roleListUuids = this.getRoleList.filter((item) => item.role == 1).map((item) => item.uuid)
      return msg.data.role == 1 || roleListUuids.includes(msg.data.uuid)
    },
    handleEmojiClick(event) {
      this.showEmojiBox = false
      this.content += event.srcElement?.id
      this.$refs.textarea.focus()
    },
    scrollBottom(isNow = false, element = '') {
      // 滚动到底部 有如下几种判断
      // 刚进入文字互动 包括有记录or没记录情况
      // 本机发送消息 看滚动位置是否到底部
      // 其他人发消息  看滚动位置是否到底部
      // 下拉获取更多消息 不滚动 或者按照当前位置判断
      this.$nextTick(() => {
        if (this.bscroll) {
          this.bscroll.refresh()
          // console.log(this.bscroll.maxScrollY, this.bscroll.y);
          if (isNow) {
            this.bscroll.scrollTo(0, this.bscroll.maxScrollY, 0, 'swipeBounce')
            return
          }
          if (this.bscroll.maxScrollY - this.bscroll.y > -100) {
            this.bscroll.scrollTo(0, this.bscroll.maxScrollY, 0, 'swipeBounce')
            return
          }
          if (element) {
            this.bscroll.scrollToElement(element, 0)
          }
        }
      })
    },
    handleCtxChange() {
      if (this.content.trim().length === 0) {
        this.showCtxTip = true
      } else {
        this.showCtxTip = false
      }
    },
    roomOnlineNumChange(onlineNum) {
      this.onlineNum = onlineNum
    },
    initBscroll() {
      console.log(this.$refs.chatRecord)
      this.bscroll = new BScroll(this.$refs.chatRecord, {
        scrollY: true,
        momentum: false,
        mouseWheel: true,
        bounceTime: 200,
        bounce: {
          bottom: false,
        },
        pullDownRefresh: {
          threshold: 70,
          stop: 56,
        },
      })
      this.bscroll.on('pullingDown', this.pullingDownHandler)
      this.bscroll.on('scroll', this.scrollHandler)
      this.bscroll.on('scrollEnd', (e) => {
        // console.log('scrollEnd')
        if (this.scrollPulldownNum > 56) {
          this.pullingDownHandler()
        }
        this.scrollPulldownNum = 0
      })
    },
    scrollHandler(pos) {
      // console.log(pos.y)
      if (pos.y > this.scrollPulldownNum) {
        this.scrollPulldownNum = pos.y
      }
    },
    async pullingDownHandler() {
      console.log('pullingDownHandler')
      this.beforePullDown = false
      this.isPullingDown = true
      let startTime = ''
      if (this.getIMMsgList.length) {
        startTime = this.getIMMsgList[0].data.sendTime
      }
      await this.getChatRecords(startTime)
      this.$nextTick(() => {
        this.bscroll.finishPullDown()
        this.beforePullDown = true
        this.bscroll.refresh()
      })
    },
    /**
     * @description: 获取历史记录
     * @param {*}
     * @return {*}
     */
    async getChatRecords(startTime = '') {
      const len = this.getIMMsgList.length
      const data = await this.$http.getChatRecords({
        mainLiveId: this.liveId || '',
        startTime: startTime,
        uuid: `admin_${this.userInfo.userId}` || '',
      })
      console.log('聊天记录列表', data)
      if (data.code !== 200) return this.$message.error(data.msg)
      const msgList = (data.rt?.chatRecords || []).map((item) => {
        return {
          data: {
            ...item,
            message: decodeURIComponent(item.message),
          },
        }
      })
      if (startTime == '') {
        this.setIMMsgList(msgList)
        this.scrollBottom(true)
      } else {
        const element = len
          ? this.$refs.msgItemList[this.getIMMsgList.length - len]
          : ''
        this.setIMMsgList([...msgList, ...this.getIMMsgList])
        this.scrollBottom(false, element)
      }
    },
    /**
     * @description: 禁言 解禁用户变化
     * @param {*} msg
     * @return {*}
     */
    forbidUserChange(msg) {
      if (msg.data.status == 1) {
        // 禁言
        if (!this.forbidUsers.includes(msg.data.uuid)) {
          this.forbidUsers.push(msg.data.uuid)
        }
      } else {
        // 解禁
        const fIndex = this.forbidUsers.findIndex(
          (item) => item == msg.data.uuid
        )
        if (fIndex != -1) {
          this.forbidUsers.splice(fIndex, 1)
        }
      }
    },
    /**
     * @description: 禁言用户
     * @param {*} item
     * @return {*}
     */
    async forbidChat(item, operate = 0) {
      const res = await this.$http.forbidChat({
        mainLiveId: this.liveId || '',
        operate,
        uuid: item.data.uuid || '',
        operatorId: `admin_${this.userInfo.userId}` || '',
        operatorRole: 4,
      })
      console.log('禁言结果', res)
    },
    /**
     * @description: 获取禁言列表
     * @param {*}
     * @return {*}
     */
    async getForbidChatUsers() {
      console.warn('getForbidChatUsers')
      const data = await this.$http.getForbidChatUsers({
        mainLiveId: this.liveId || '',
      })
      console.log('禁言列表', data)
      if (data.code != 200) return
      this.forbidUsers = data.rt?.forbidUsers || []
    },
    /**
     * @description: 根据双方身份判断是否可以禁言
     * @param {*}
     * @return {*}
     */
    canIForbidUser(msg) {
      const roleListUuids = this.getRoleList.filter((item) => item.role == 1).map((item) => item.uuid)
      if (msg.data.role == '1' || roleListUuids.includes(msg.data.uuid)) {
        // 对方为主讲 主讲不可以被禁言
        return false
      } else {
        // 对方是学生 助教 督学 己方是 助教 主讲 督学 则可以进行禁言和解禁
        // 主讲和助教也是可以解禁自己的
        return true
      }
    },
    async getLiveOnlineNum() {
      const data = await this.$http.getLiveOnlineNum({
        mainLiveId: this.liveId,
      })
      if (data.code !== 200) return this.$message.error(data.msg)
      if (data.rt.resultStatus === -1) {
        // 这里不要提示：
        // return this.$message.error(result.rt.resultMessage)
        return
      }
      this.onlineNum = data.rt.roomOnlineNum
    },
    /**
     * @description: 发送聊天室文本消息
     * @param {*}
     * @return {*}
     */
    sendChatTextMsg() {
      if (this.content.trim().length == 0) {
        this.showCtxTip = true
        return
      }
      const sendChatroomMsgDone = async (error, msg) => {
        console.log(
          '发送聊天室' +
            msg.type +
            '消息' +
            (!error ? '成功' : '失败') +
            ', id=' +
            msg.idClient,
          error,
          msg
        )
        this.content = ''
        this.addIMMsg(JSON.parse(msg.text || '{}'))
        const res = await this.$http.saveChatRecord({
          mainLiveId: this.liveId,
          message: encodeURIComponent(
            JSON.parse(msg.text)?.data?.message || ''
          ),
          sendTime: msg.time,
          uuid: `admin_${this.userInfo.userId}` || '',
          nickName: this.userInfo.name || '',
          avatar: this.userInfo.userImg || '',
          isVipUser: 0,
          role: 4 || '',
        })
        console.warn('保存聊天记录', res)
      }
      console.log(this.userInfo)
      const data = {
        userId: this.userId,
        message: this.content.trim(),
        nickName: this.userInfo.name,
        avatar: this.userInfo.userImg,
        isVipUser: 0,
        zhsUserId: this.userId,
        role: 4,
        uuid: `admin_${this.userInfo.userId}`,
        liveId: this.liveId,
        sendTime: +new Date(),
      }
      const msg = this.chatroom.sendText({
        text: this.sendMessageFormat('4025', data, true),
        done: sendChatroomMsgDone,
      })
      // 测试版本发布
      console.log('正在发送聊天室text消息, id=' + msg.idClient)
    },
    // 获取聊天室历史聊天记录
    getChatroomMsgHistoryList() {
      console.warn(this.chatroom)
      if (!this.chatroom) return
      console.log('获取聊天室历史聊天记录')
      const getHistoryMsgsDone = (error, obj) => {
        console.log(
          '获取聊天室历史' + (!error ? '成功' : '失败'),
          error,
          obj.msgs
        )
        if (obj.msgs?.length) {
          const msgArr = obj.msgs
            ?.map((item) => {
              return JSON.parse(item.text)
            })
            ?.reverse()
          const msgArrFilter = msgArr.filter((item) => {
            return item.data.message != '' && item.data.message != undefined
          })
          console.log('msgArrFilter', msgArrFilter)
          this.setIMMsgList(msgArrFilter)
        }
        this.scrollBottom()
      }
      this.chatroom.getHistoryMsgs({
        limit: 100,
        msgTypes: ['text'],
        done: getHistoryMsgsDone,
      })
    },
    /**
     * @description: 处理网易IM格式化成智慧树的websocket信息格式
     * @param {*}
     * @return {*}
     */
    sendMessageFormat(type, data, isString) {
      const msgFormat = {
        lcId: this.liveId,
        id: `${new Date().getTime()}${Math.ceil(Math.random() * 100000)}`,
        from: this.userId,
        to: 'all',
        type,
        data,
      }
      if (isString) {
        return JSON.stringify(msgFormat)
      }
      return msgFormat
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .chatroom_emoji {
  width: 26px;
  height: 26px;
  display: inline-block;
  background-image: url('../../assets/img/face.png');
  transform: scale(0.6);
  vertical-align: middle;
}
.chat_room {
  width: 100%;
  height: 100%;
  background-color: #10121a;
  color: #fff;
  display: flex;
  flex-direction: column;
  .chat_record {
    padding: 0 16px;
    height: calc(100% - 156px);
    overflow: hidden;
    position: relative;
    .record_content {
      .pulldown-tips {
        color: #fff;
        text-align: center;
        margin-bottom: 10px;
        opacity: 0.5;
      }
    }
    .msg_item {
      margin-bottom: 20px;
      .user_info {
        display: flex;
        justify-content: flex-start;
      }
      .avatar {
        position: relative;
        img {
          width: 24px;
          height: 24px;
          vertical-align: bottom;
          border-radius: 50%;
        }
        &:hover {
          .no_sound {
            display: flex;
          }
        }
        .no_sound {
          display: none;
          position: absolute;
          left: 0;
          top: 0;
          width: 24px;
          height: 24px;
          background: rgba(0, 0, 0, 0.6);
          justify-content: center;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
            padding: 4px;
            cursor: pointer;
          }
        }
      }
      .name {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9fa2b1;
        margin-left: 3px;
        padding: 4px 5px;
        max-width: 100px;
        overflow: hidden;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //用省略号显示
        white-space: nowrap; //不换行
      }
      .msg_ctx {
        display: inline-block;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 18px;
        color: #9fa2b1;
        background-color: #222326;
        margin-left: 28px;
        padding: 8px;
        border-radius: 4px;
        max-width: 172px;
        word-break: break-word;
      }
    }
    .msg_item_mine {
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .user_info {
        display: flex;
        justify-content: flex-end;
      }
      .avatar {
        position: relative;
        img {
          width: 24px;
          height: 24px;
          vertical-align: bottom;
          border-radius: 50%;
        }
        &:hover {
          .no_sound {
            display: flex;
          }
        }
        .no_sound {
          display: none;
          position: absolute;
          left: 0;
          top: 0;
          width: 24px;
          height: 24px;
          background: rgba(0, 0, 0, 0.6);
          justify-content: center;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
            padding: 4px;
            cursor: pointer;
          }
        }
      }
      .name {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9fa2b1;
        margin-right: 3px;
        padding: 4px 5px;
        max-width: 100px;
        overflow: hidden;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //用省略号显示
        white-space: nowrap; //不换行
      }
      .msg_ctx {
        display: inline-block;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 18px;
        color: #fff;
        background-color: #1d3355;
        margin-right: 28px;
        padding: 8px;
        word-break: break-word;
        border-radius: 4px;
        max-width: 172px;
      }
    }
  }
  .chat_send {
    width: 100%;
    height: 156px;
    padding: 26px 16px 20px 21px;
    background-color: #161a26;
    .forbid_info_box {
      margin-top: 10px;
      width: 240px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #777777;
      padding-left: 10px;
    }
    > div:nth-child(1) {
      display: flex;
      justify-content: space-between;
      img {
        width: 20px;
        height: 20px;
      }
      > div:nth-child(1) {
        span {
          color: red;
          font-size: 12px;
          margin-left: 8px;
        }
      }
      > div:nth-child(2) {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9fa2b1;
        span {
          color: #fff;
        }
      }
    }
    > div:nth-child(2) {
      margin-top: 10px;
      color: #9fa2b1;
      position: relative;
      textarea {
        background: #232838;
        height: 80px;
        padding: 10px 16px;
        border: none;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
      }
      .emoji_box {
        position: absolute;
        top: -320px;
        width: 268px;
        height: 273px;
        border: 1px solid #e1e1e1;
        background-color: #fff;
        background-image: url('../../assets/img/emojis.png');
        .emotion {
          ul {
            list-style: none;
          }
          li {
            list-style: none;
            float: left;
            width: 33px;
            height: 34px;
            cursor: pointer;
            &:hover {
              border: 1px solid #e1e1e1;
            }
          }
        }
      }
    }
  }
}
</style>